/** FBANo：FBA + 9 位字母数字，例如 FBA19KLD9NBT */
export const FBA_NO_PATTERN = /^FBA[A-Z0-9]{9}$/i

/** 预约号：8 位字母数字，例如 78TFJ6QS */
export const RE_ID_PATTERN = /^[A-Z0-9]{8}$/i

export function isValidFbaNo(value) {
  if (value === undefined || value === null || String(value).trim() === '') return true
  return FBA_NO_PATTERN.test(String(value).trim())
}

export function isValidReId(value) {
  if (value === undefined || value === null || String(value).trim() === '') return true
  return RE_ID_PATTERN.test(String(value).trim())
}

export function getFbaNoError(value) {
  return isValidFbaNo(value) ? '' : 'FBANo 格式不正确，应为 FBA + 9 位字母或数字，例如 FBA19KLD9NBT'
}

export function getReIdError(value) {
  return isValidReId(value) ? '' : '预约号格式不正确，应为 8 位字母或数字，例如 78TFJ6QS'
}

export function validateFbaFields(fbaNo, reId) {
  return getFbaNoError(fbaNo) || getReIdError(reId) || ''
}

export function createFbaNoRule(required = false) {
  const rules = []
  if (required) {
    rules.push({ required: true, message: '请填FBA NO', trigger: 'blur' })
  }
  rules.push({
    validator: (rule, value, callback) => {
      const err = getFbaNoError(value)
      err ? callback(new Error(err)) : callback()
    },
    trigger: 'blur'
  })
  return rules
}

export function createReIdRule(required = false) {
  const rules = []
  if (required) {
    rules.push({ required: true, message: '请填写预约号', trigger: 'blur' })
  }
  rules.push({
    validator: (rule, value, callback) => {
      const err = getReIdError(value)
      err ? callback(new Error(err)) : callback()
    },
    trigger: 'blur'
  })
  return rules
}

export function validateVolumeCargoList(volumeCargoList) {
  if (!volumeCargoList || !volumeCargoList.length) return ''
  for (let i = 0; i < volumeCargoList.length; i++) {
    const item = volumeCargoList[i]
    const err = validateFbaFields(item.fbaNo, item.reId)
    if (err) return `第 ${i + 1} 个箱规：${err}`
  }
  return ''
}

export function validateCargoList(cargoList) {
  if (!cargoList || !cargoList.length) return ''
  for (let i = 0; i < cargoList.length; i++) {
    const item = cargoList[i]
    const err = validateFbaFields(item.fbaNo, item.reId)
    if (err) return `第 ${i + 1} 条货物：${err}`
  }
  return ''
}
